import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-licence-form',
  templateUrl: './licence-form.component.html',
  styleUrls: ['./licence-form.component.css']
})
export class LicenceFormComponent implements OnInit {
  title="Licence";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/functions/licence/licence-form/licence-form.component.ts